/* eslint-disable max-statements-per-line */
/* eslint-disable complexity */
/* eslint-disable no-use-before-define */
/* eslint-disable max-statements */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Card, Modal, Select, Switch } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { isEmpty, findIndex } from 'lodash';
import axiosInstance from 'Src/common/utilities/axios_util';
import EmailDisplayBlock from 'Src/common/components/emailDisplayBlock';
import Almasights from 'almasights';
import { Tooltip } from 'arcl';
import ProfileListItem from '../profileListItem';
import { MESSAGES } from './constants';

import './style.scss';

const ALLOWED_EMAIL_PREFERENCES = ['Allowed by Admin', 'Allowed by Self', 'Allowed for transaction'];
const DENIED_EMAIL_PREFERENCES = ['Denied by Admin', 'Denied by Self', 'Denied for transaction'];

const DEFAULT_EMAIL_TYPES = [
  {
    slug: 'Personal',
    name: 'Personal',
  },
  {
    slug: 'Work',
    name: 'Work',
  },
];

/**
 * Add Email component
 * @param {*} record - a mapped profile
 * @param {*} isVFXEnabled - is vfx enabled for site
 * @param {*} activityData - activityData
 * @param {*} onAddEmail - callback
 */
function AddEmail({ record, isVFXEnabled, activityData, onAddEmail }) {
  const { email_addresses: emailAddresses } = record;
  const { can_email: canEmail, formatted_name: formattedName } = record;
  const [emailTypes, setEmailTypes] = useState([]);
  const [selectedEmailType, setSelectedEmailType] = useState(null);
  const [isNotificationOn, setIsNotificationOn] = useState(getInitialNotificationState());
  const [isPrimaryEmailOn, setIsPrimaryEmailOn] = useState(getInitialPrimaryEmailState());
  // eslint-disable-next-line no-unused-vars
  const [isNotificationDisabled, setIsNotificationDisabled] = useState(getInitialNotificationDisabledState());
  const [isPrimaryEmailDisabled, setIsPrimaryEmailDisabled] = useState(getInitialPrimaryEmailDisabledState());
  const [loading, setLoading] = useState(false);
  const [isAddEmailModalVisible, setIsAddEmailModalVisible] = useState(false);

  /**
   * if email address array is blank it means email will be first one to be added to record
   */
  function isFirstEmail() {
    return isEmpty(emailAddresses);
  }

  /**
   * get old primary email address
   */
  function getOldPrimaryEmail() {
    const index = findIndex(emailAddresses, (val) => val.is_primary);
    if (index > -1) {
      return emailAddresses[index].address;
    }
    return null;
  }

  /**
   * get modal text
   */
  function getModalText() {
    if (ALLOWED_EMAIL_PREFERENCES.includes(canEmail)) {
      if (isFirstEmail()) {
        return MESSAGES.canEmailAllowed.firstEmail;
      }
      if (isNotificationOn) {
        return MESSAGES.canEmailAllowed.notFirstEmail.notify;
      }
      if (!isNotificationOn && isPrimaryEmailOn) {
        return MESSAGES.canEmailAllowed.notFirstEmail.doNotNotify.primary;
      }
      if (!isNotificationOn && !isPrimaryEmailOn) {
        return MESSAGES.canEmailAllowed.notFirstEmail.doNotNotify.nonPrimary;
      }
    } else if (DENIED_EMAIL_PREFERENCES.includes(canEmail)) {
      if (isFirstEmail()) {
        return MESSAGES.canEmailDenied.firstEmail;
      }
      if (isNotificationOn) {
        return MESSAGES.canEmailDenied.notFirstEmail.notify;
      }
      if (!isNotificationOn && isPrimaryEmailOn) {
        return MESSAGES.canEmailDenied.notFirstEmail.doNotNotify.primary;
      }
      if (!isNotificationOn && !isPrimaryEmailOn) {
        return MESSAGES.canEmailDenied.notFirstEmail.doNotNotify.nonPrimary;
      }
    }
  }

  /**
   * confirmation before adding to email
   */
  function confirmAddEmailToRecord() {
    if (!isPrimaryEmailOn && !isNotificationOn) {
      addEmailToRecord();
    } else {
      setIsAddEmailModalVisible(true);
    }
  }

  /**
   * Adding email to record
   */
  function addEmailToRecord() {
    setLoading(true);
    axiosInstance({
      method: 'post',
      url: `/profiles/${record.id}/email_addresses`,
      data: {
        address: activityData.email,
        type: selectedEmailType,
        should_notify: isNotificationOn,
        is_primary: isPrimaryEmailOn,
        profile_id: record.id,
        source: 'Mapper Service',
      },
    })
      .then(() => {
        setLoading(false);
        onAddEmail();
        setIsAddEmailModalVisible(false);
        const almasightsInstance = new Almasights({
          parentObject: {
            type: 'site',
            id: window.siteId,
            name: window.siteName,
          },
          url: '/api/v1/almasights/touchpoints/',
        });
        almasightsInstance.trackEvent({
          touchpointType: 'userprofile-added-email-to-record',
          triggerType: 'click',
          authToken: window.csrfToken,
          object: null,
          customMetadata: [
            {
              key: 'is_primary',
              value: isPrimaryEmailOn,
            },
            {
              key: 'should_notify',
              value: isNotificationOn,
            },
          ],
        });
      })
      .catch(() => {
        setLoading(false);
      });
  }

  /**
   * Get initial value of notification toggle
   */
  function getInitialNotificationState() {
    return true;
  }

  /**
   *
   */
  function getInitialPrimaryEmailState() {
    if (isEmpty(emailAddresses)) {
      return true;
    }
    return false;
  }

  /**
   *
   */
  function getInitialNotificationDisabledState() {
    if (isEmpty(emailAddresses)) {
      return true;
    }
    return false;
  }

  /**
   *
   */
  function getInitialPrimaryEmailDisabledState() {
    return true;
  }

  /**
   *  gets email types from backend
   */
  function getEmailIdTypes() {
    return axiosInstance({
      method: 'get',
      url: '/profiles/email_types/?skip_pagination=1',
    });
  }

  /**
   *
   * @param {*} checked
   * @param {*} e
   */
  function changeNotificationToggle(checked) {
    if (!checked) {
      setIsPrimaryEmailDisabled(false);
    } else {
      setIsPrimaryEmailDisabled(true);
      setIsPrimaryEmailOn(false);
    }
    setIsNotificationOn(checked);
  }

  useEffect(() => {
    getEmailIdTypes().then((res) => {
      if (isEmpty(res.data)) {
        setEmailTypes(DEFAULT_EMAIL_TYPES);
        setSelectedEmailType(DEFAULT_EMAIL_TYPES[0].name);
      } else {
        setEmailTypes(res.data);
        setSelectedEmailType(res.data[0].name);
      }
    });
  }, []);

  /**
   * Function to decide whether to show tooltip or not for a switch
   */
  function hasTooltip() {
    return isFirstEmail() || (isNotificationOn && !isPrimaryEmailOn && isPrimaryEmailDisabled);
  }

  /**
   * Get tooltip text
   */
  function getTooltipText() {
    if (isFirstEmail()) {
      return "This is the first email on record. We'll set it as primary and ask the user for further preferences.";
    }
    if (isNotificationOn && !isPrimaryEmailOn && isPrimaryEmailDisabled) {
      return 'When notifying the user, we ask for their choice on which email should be primary.';
    }
    return '';
  }

  return (
    <div className="add-email-container arc-page-bg">
      <Card className="arc-card-box-shadow arc-card-border-radius mt4 mb16">
        <ProfileListItem record={record} isActionEnabled={false} isVFXEnabled={isVFXEnabled} />
        <p className="arc-H100 mt16">
          <FontAwesomeIcon icon={faInfoCircle} />
          <span className="ml4">
            <span className="arc-font-weight-bold">Email Preferences:</span>{' '}
            <span
              className={`arc-support-text arc-font-weight-400 ${
                ALLOWED_EMAIL_PREFERENCES.indexOf(canEmail) > -1 ? 'arc-color-success' : 'arc-color-error'
              }`}>
              {canEmail}
            </span>
          </span>
        </p>
        <p className="arc-H100 current-label arc-color-white mt16 pt2 pb2 pl4 pr4">CURRENT</p>
        <p className="mt8">
          {isEmpty(emailAddresses) && (
            <p className="arc-p arc-color-B65">There are no emails on this record currently</p>
          )}
          {emailAddresses.map((emailAddress, index) => (
            <EmailDisplayBlock key={index} emailAddress={emailAddress} />
          ))}
        </p>
      </Card>
      <Card className="arc-card-box-shadow arc-card-border-radius mb16">
        <div className="new-email-container">
          <p className="arc-H100 new-label arc-color-white pt2 pb2 pl4 pr4">NEW</p>
          <p className="arc-H150 arc-font-weight-400 arc-color-black mt8">{activityData.email}</p>
          <p className="arc-support arc-color-B45">
            <span>Save as</span>
            <Select value={selectedEmailType} className="ml8 no-border" onChange={(val) => setSelectedEmailType(val)}>
              {emailTypes.map((emailType) => (
                <Select.Option key={emailType.name} value={emailType.name}>
                  {emailType.name}
                </Select.Option>
              ))}
            </Select>
          </p>
        </div>
        <div className="notification-block arc-d-flex arc-flex-v-align-middle mt16">
          <Choose>
            <When condition={isFirstEmail()}>
              <Tooltip title={getTooltipText()} variant="simple" toolTipProps={{ placement: 'topLeft' }}>
                <Switch
                  size="small"
                  checked={isNotificationOn}
                  disabled={isNotificationDisabled}
                  onChange={changeNotificationToggle}
                />
                <span className="arc-p arc-color-B85 ml8">Notify the user & ask to set preferences</span>
              </Tooltip>
            </When>
            <Otherwise>
              <Switch
                size="small"
                checked={isNotificationOn}
                disabled={isNotificationDisabled}
                onChange={changeNotificationToggle}
              />
              <span className="arc-p arc-color-B85 ml8">Notify the user & ask to set preferences</span>
            </Otherwise>
          </Choose>
        </div>
        <div className="primary-email-block arc-d-flex arc-flex-v-align-middle mt8">
          <Choose>
            <When condition={hasTooltip()}>
              <Tooltip title={getTooltipText()} variant="simple" toolTipProps={{ placement: 'topLeft' }}>
                <Switch
                  size="small"
                  checked={isPrimaryEmailOn}
                  disabled={isPrimaryEmailDisabled}
                  onChange={(checked) => setIsPrimaryEmailOn(checked)}
                />
                <span className="arc-p arc-color-B85 ml8">Mark this email as primary</span>
              </Tooltip>
            </When>
            <Otherwise>
              <Switch
                size="small"
                checked={isPrimaryEmailOn}
                disabled={isPrimaryEmailDisabled}
                onChange={(checked) => setIsPrimaryEmailOn(checked)}
              />
              <span className="arc-p arc-color-B85 ml8">Mark this email as primary</span>
            </Otherwise>
          </Choose>
        </div>
      </Card>
      <Button block type="primary" size="large" onClick={confirmAddEmailToRecord} loading={loading}>
        Add Email
      </Button>
      <If condition={isAddEmailModalVisible}>
        <Modal
          wrapClassName="preference-confirmation-modal"
          title={null}
          visible
          onOk={addEmailToRecord}
          onCancel={() => setIsAddEmailModalVisible(false)}
          confirmLoading={loading}
          okText="Proceed, Add to record"
          cancelText="Go back"
          closable={false}
          centered>
          <p className="arc-p arc-color-B65">By proceeding,</p>
          <ul className="message-container mt8">
            {getModalText().map((message, index) => (
              <li key={index} className="arc-p arc-color-B65">
                {message.text
                  .replace('<name>', formattedName)
                  .replace('<email>', activityData.email)
                  .replace('<old_email>', getOldPrimaryEmail())}
              </li>
            ))}
          </ul>
          <If condition={!isFirstEmail() && !isNotificationOn}>
            <p className="arc-p arc-color-B65 mt16">
              If you are unsure, we recommend going back and notifying this person to verify if this is their email.
            </p>
          </If>
        </Modal>
      </If>
    </div>
  );
}

export default AddEmail;
